<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        class="bonus-info"
        :class="[data?.background_color === 'black' ? 'white' : '']"
      >
        <NuxtImg
          v-if="data?.image && data?.image?.src && data?.image?.alt"
          :src="data.image.src"
          :alt="data.image.alt"
          :height="data.image.height"
          :width="data.image.width"
          class="bonus-info__image"
          data-aos="zoom-in"
          data-aos-easing="ease-out-quad"
          loading="lazy"
        />
        <h2
          v-if="data?.title"
          class="mb-0 bonus-info__title h2"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data?.title"
        ></h2>
        <ul v-if="data.items" class="m-0 p-0 bonus-info__items">
          <li
            v-for="(item, itemIndex) in data.items"
            :key="itemIndex"
            class="m-0 bonus-info__item"
            data-aos="fade-up"
            :data-aos-delay="itemIndex >= 1 ? 100 + 100 * itemIndex : 100"
          >
            <CIcon
              name="state"
              width="32"
              height="32"
              class="bonus-info__item-icon"
            />
            <span class="bonus-info__item-title accent" v-html="item"></span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.bonus-info {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    text-align: center;
    @include media-breakpoint-up(md) {
      width: 66.6%;
    }
  }
  &__image {
    height: auto;
    margin: 0 auto;
    width: 100%;
    @include media-breakpoint-up(md) {
      width: 64.9%;
    }
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;
    list-style: none;
    @include media-breakpoint-up(sm) {
      gap: 48px;
      margin: 0 auto;
      max-width: 50%;
    }
    @include media-breakpoint-up(md) {
      gap: 16px;
      grid-template-columns: repeat(3, 1fr);
      max-width: unset;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
  &__item {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
    &-icon {
      height: 32px;
      width: 32px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(height, 32);
        @include responsive-spacing(width, 32);
      }
    }
  }
}
</style>
